/**
 * VerzendModal - Modal voor het verzenden van offerte per email
 */

import { useState } from 'react';
import './VerzendModal.css';

interface VerzendModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (email: string) => void;
  onGenereerPDF: () => void;
  defaultEmail?: string;
  offertenummer: string;
  isGeneratingPDF?: boolean;
  type?: 'offerte' | 'factuur';
}

const VerzendModal = ({
  isOpen,
  onClose,
  onConfirm,
  onGenereerPDF,
  defaultEmail = '',
  offertenummer,
  isGeneratingPDF = false,
  type = 'offerte'
}: VerzendModalProps) => {
  const [email, setEmail] = useState(defaultEmail);
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Valideer email
    if (!email || email.trim() === '') {
      setError('Email adres is verplicht');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Ongeldig email adres');
      return;
    }

    setError(null);
    onConfirm(email);
  };

  const handleClose = () => {
    setError(null);
    setEmail(defaultEmail);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{type === 'factuur' ? 'Factuur' : 'Offerte'} Verzenden</h2>
          <button className="modal-close" onClick={handleClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <p>
              U staat op het punt om <strong>{type === 'factuur' ? 'factuur' : 'offerte'} {offertenummer}</strong> te verzenden als PDF per email.
            </p>

            <div className="form-group">
              <label htmlFor="email">Email adres ontvanger:</label>
              <input
                type="email"
                id="email"
                className="form-control"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(null);
                }}
                placeholder="voorbeeld@email.nl"
                autoFocus
              />
              {error && <div className="error-message">{error}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-info"
              onClick={onGenereerPDF}
              disabled={isGeneratingPDF}
              style={{ marginRight: 'auto' }}
            >
              {isGeneratingPDF ? 'PDF Genereren...' : '📄 Genereer PDF'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>
              Annuleren
            </button>
            <button type="submit" className="btn btn-primary">
              Verzenden
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerzendModal;
